<x-shop-layout>
  <x-shop-header *ngIf="(rc.routeTransition$ | async) !== true" headerStyle="custom">
    <x-header-layout>
      <x-brand-logo xHeading xRedirectBack></x-brand-logo>
    </x-header-layout>
  </x-shop-header>

  <div xBody class="x-channel-gateway-body py-5" *ngIf="(rc.routeTransition$ | async) !== true">
    <div class="container" *ngIf="channelsOptions$ | async as channels">
      <div class="row justify-content-center">
        <div class="channel-selection-wrapper">
          <div class="channel-selection">
            <x-brand-emblem></x-brand-emblem>

            <h3 i18n="@@Page.ChannelSelect.Title">Where are you Shipping to?</h3>
            <p i18n="@@Page.ChannelSelect.SubTitle">
              Choosing your shipping country will determine products, pricing, and shipping times.
            </p>

            <div class="channels">
              <div
                *ngFor="let channel of channels; trackBy: 'code' | trackBy"
                class="channel"
                (click)="gotoChannel(channel)"
              >
                <x-flag-icon
                  [flag]="channel.code === 'int' ? channel.code : channel.defaultCountry"
                ></x-flag-icon>
                <div class="content">
                  <div class="name">
                    {{ channel.name }}
                  </div>
                  <div *ngIf="channel.code !== 'int'" class="description mat-caption">
                    <ng-container i18n="@@Page.ChannelGateway.ShippedFrom">
                      Shipped from&nbsp;
                    </ng-container>
                    {{ channel.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button type="button" mat-button xButtonType="link" xNeedHelp color="primary">
            <fa-icon icon="question"></fa-icon>
            <span i18n="@@CallToAction.NeedHelp">Help</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="channel-loader" xLoaderContent>
    <x-brand-emblem></x-brand-emblem>
    <x-brand-title></x-brand-title>
  </div>
</x-shop-layout>
